import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('lessons');

const lessonsRoutes = [
  {
    path: '/lessons',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '',
        component: loadView('Lessons'),
        children: [
          {
            path: '/',
            name: 'lessons',
            props: true,
            component: loadView('LessonsMain'),
            meta: {
              feature: 'lessons',
            },
          },
          {
            path: 'folder/:folder_id',
            name: 'lessonsInFolder',
            props: true,
            component: loadView('LessonsMain'),
            meta: {
              feature: 'lessons',
            },
          },
        ],
      },
      {
        path: 'new/:folder_id?',
        name: 'lessonCreate',
        component: loadView('LessonCreate'),
        meta: {
          feature: 'lessons',
        },
      },
      {
        path: 'edit/:id/:flags?',
        name: 'lessonEdit',
        props: true,
        component: loadView('lessonEdit/LessonEdit'),
        meta: {
          feature: 'lessons',
        },
      },
      {
        path: 'take/:id/:action?',
        name: 'lessonTake',
        props: true,
        component: loadView('LessonTake'),
        meta: {
          feature: 'lessons',
        },
      },
      {
        path: 'test/:id',
        name: 'lessonTest',
        props: true,
        component: loadView('LessonTake'),
        meta: {
          feature: 'lessons',
        },
      },
      {
        path: 'metrics/:lessonId/:triggerId?',
        name: 'lessonMetrics',
        props: true,
        component: loadView('metrics/LessonMetrics'),
        meta: {
          feature: 'lessons',
        },
      },
    ],
  },
];

export default lessonsRoutes;
